import { ArrowchevronDownIcon, ArrowchevronUpIcon } from '@bfe/moly-icons';
import { useMemo, useState } from 'react';
import LinesEllipsis from './LinesEllipsis';
import { isMobile } from '@web3/base-utils';

type ITextClamp = {
  // children: React.ReactNode,
  text: string;
  line?: number;
  className?: string;
};
export function TextClamp(props: ITextClamp) {
  const { text, line = 2, className = 'text-gray1 text-base mt-6' } = props;
  const [curLine, setLine] = useState(line);

  const renderText = useMemo(() => {
    if (curLine === line) {
      return text;
    } else {
      return (
        <span className="text-gray1">
          {text}
          <span
            className="text-gray1 cursor-pointer inline-flex items-center"
            onClick={() => setLine(line)}
          >
            &nbsp;
            <ArrowchevronUpIcon className={isMobile ? 'w-4 h-4' : 'w-5 h-5'} />
          </span>
        </span>
      );
    }
  }, [curLine, text, line]);

  return (
    <LinesEllipsis
      text={renderText}
      maxLine={curLine}
      ellipsis={
        <span
          className="text-gray1 cursor-pointer inline-flex items-center"
          onClick={() => setLine(999)}
        >
          ...
          <ArrowchevronDownIcon className={isMobile ? 'w-4 h-4' : 'w-5 h-5'} />
        </span>
      }
      trimRight
      basedOn="letters"
      className={`${className} relative`}
    />
  );
}
